<div class="shipping-component">
  <form class="shipping-form" [formGroup]="shippingForm">

    <div class="row one">
      <label class="full-input">Job Site Name
        <input class="full-input-input" type="text" formControlName="company">
      </label>
    </div>

    <div class="row one">
      <label class="full-input">Address 1
        <input class="full-input-input" type="text" formControlName="street1">
      </label>
    </div>

    <div class="row one">
      <label class="full-input">Address 2
        <input class="full-input-input" type="text" formControlName="street2">
      </label>
    </div>

    <div class="row three">
      <label>City <span class="required">*</span>
        <input type="text" formControlName="city" [class.invalid-field]="isInvalid('city')">
        <cx-form-errors [control]="shippingForm.get('city')"></cx-form-errors>
      </label>
      <label>State/Province/District <span class="required">*</span>
        <ng-select [items]="this.stateList" bindLabel="name" bindValue="isocode" formControlName="state">
        </ng-select>
        <cx-form-errors [control]="shippingForm.get('state')"></cx-form-errors>
      </label>
      <label>ZIP / Postal Code <span class="required">*</span>
        <input type="text" formControlName="postal" maxlength="5" [class.invalid-field]="isInvalid('postal')">
        <cx-form-errors [control]="shippingForm.get('postal')"></cx-form-errors>
      </label>
    </div>

    <div class="row three">
      <label>Country / Region <span class="required">*</span>
        <ng-select [class.invalid-field]="isInvalid('country')" [items]="this.usaCanadaMexicoCountryList"
          bindLabel="name" bindValue="isocode" (change)="countrySelected($event, 'shipping')" formControlName="country"
          [ngModel]="defaultedCountry" [loading]="isCountryLoading">
        </ng-select>
        <cx-form-errors [control]="shippingForm.get('country')"></cx-form-errors>
      </label>
      <label>Phone
        <input type="text" formControlName="phone"
          (input)="formatPhoneNumber()" placeholder="(123) 456-7890">
          <cx-form-errors [control]="shippingForm.get('phone')"></cx-form-errors>
      </label>
    </div>

    <!-- Additional Information Header -->
    <div class="row one">
      <span class="additional-info-header">Additional Information</span>
    </div>
    <div class="row one">
      <label>Multiple Shipments</label>
    </div>
    <!-- Multiple Shipment Section -->
    <div class="row one">
      <div class="shipment-container">
        <span class="shipment-question">Do you require multiple shipments for this request?</span>
        <div class="radio-options">
          <label class="radio-option">
            <input type="radio" formControlName="multipleShipment" [value]="true" id="multipleShipmentYes">
          </label>
           <label for="multipleShipmentYes">Yes</label>
          <label class="radio-option">
            <input type="radio" formControlName="multipleShipment" [value]="false" id="multipleShipmentNo">
          </label>
          <label for="multipleShipmentNo">No</label>
        </div>
      </div>
    </div>

    <!-- Additional Comments Section -->
    <div class="row one">
      <label class="full-input">Additional Comments
        <textarea rows="3" formControlName="comments" placeholder="Enter your comments..."></textarea>
      </label>
    </div>

    <!-- File Upload Section -->
    <div class="row one">
      <div class="file-upload-section">
        <label class="file-upload-label">Upload Files (Optional)</label>
        <div class="file-upload-area" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
          <p class="upload-text">
            <i class="fas fa-cloud-upload-alt upload-icon-inline"></i>
            Drag & drop files here or
            <button type="button" class="browse-link" (click)="fileInput.click()">Browse Files</button>
          </p>
          <p class="upload-note">Upload drawings, specs, or other documents (Max. 10MB per file)</p>
          <input type="file" #fileInput hidden multiple (change)="onFileSelected($event)"
            accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.png,.dwg">
        </div>

        <!-- File Count Display -->
        <div class="file-count">{{ fileCount }} / 1000</div>

        <!-- Uploaded Files List -->
        @if (uploadedFiles.length > 0) {
        <div class="uploaded-files-list">
          @for (file of uploadedFiles; track file.name; let i = $index) {
          <div class="file-item">
            <div class="file-info">
              <i class="fas fa-file"></i>
              <span class="file-name">{{ file.name }}</span>
              <span class="file-size">({{ (file.size / 1024).toFixed(2) }} KB)</span>
            </div>
            <button type="button" class="remove-file-btn" (click)="removeFile(i)" aria-label="Remove file">×</button>
          </div>
          }
        </div>
        }
      </div>
    </div>
  </form>
</div>